import { CommonError } from '../../types';
import { PriceBoardActions } from './actions';
import { FETCH_PRICE_BOARD_FAILURE, FETCH_PRICE_BOARD_REQUEST, FETCH_PRICE_BOARD_SUCCESS, SET_CURRENT_PRICE } from './constants';
import {
    highestMonthPrice,
    highestYearPrice,
    lowestMonthPrice,
    lowestYearPrice,
    monthChangePersent,
    monthChangePrice,
    PriceBoard,
    yearChangePersent,
    yearChangePrice,
} from './types';

export interface PriceBoardState {
    priceBoard: PriceBoard;
    currentPrice: number;
    loading: boolean;
    error: CommonError | null;
}
const initialState = {
    priceBoard: {
        [monthChangePrice]: 0,
        [yearChangePrice]: 0,
        [monthChangePersent]: 0,
        [yearChangePersent]: 0,
        [lowestMonthPrice]: 0,
        [highestMonthPrice]: 0,
        [lowestYearPrice]: 0,
        [highestYearPrice]: 0,
    },
    currentPrice: 0,

    loading: false,
    error: null,
};
export const priceBoardReducer = (state = initialState, action: PriceBoardActions): PriceBoardState => {
    switch (action.type) {
        case FETCH_PRICE_BOARD_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_PRICE_BOARD_SUCCESS: {
            return { ...state, loading: false, priceBoard: action.payload };
        }
        case FETCH_PRICE_BOARD_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_CURRENT_PRICE:
                return { ...state, currentPrice: action.payload };
        default:
            return state;
    }
};
